let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("illcU")).then(() => parcelRequire('alkG3'));